import * as React from "react";

function SvgAlignJustifySolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M21.286 19.143H2.714a.714.714 0 00-.714.714v1.429a.714.714 0 00.714.714h18.572a.715.715 0 00.714-.714v-1.429a.714.714 0 00-.714-.714zm0-5.714H2.714a.714.714 0 00-.714.714v1.428a.714.714 0 00.714.715h18.572A.714.714 0 0022 15.57v-1.428a.714.714 0 00-.714-.714zm0-5.715H2.714A.714.714 0 002 8.43v1.428a.714.714 0 00.714.714h18.572A.714.714 0 0022 9.857V8.43a.714.714 0 00-.714-.715zm0-5.714H2.714A.714.714 0 002 2.714v1.429a.714.714 0 00.714.714h18.572A.714.714 0 0022 4.143V2.714A.715.715 0 0021.286 2z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgAlignJustifySolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
